query InstructorRemovalSnapshot($scenarioId: ID!, $originId: ID!, $resourceId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    editorView(resourceType: LINK, resourceId: $resourceId) {
      info {
        __typename
        ... on LinkInfo {
          link {
            id
            bundle {
              id
            }
            course {
              edhCanEdit
            }
            instructors {
              id
              teachingHoursPercentage
              isPrimary
              instructor {
                id
              }
            }
          }
        }
      }
    }
  }
}
